import React from 'react';
import { computed, action, makeObservable } from 'mobx';
import { observer, inject } from 'mobx-react';

import { Checkbox } from '@fluentui/react';

import SearchableComboBox from 'src/components/base/SearchableComboBox';

import PushFlowstep from 'src/components/Flowsteps/PushData/PushFlowstep';
import Step from 'src/components/Flowsteps/base/Step';

import { Type, DeleteFlowsteps, generateFlowstepName } from 'shared/utils/flowstep';



@inject('dataStore', 'officeStore', 'userStore')
class DeleteDataImpl extends PushFlowstep {

  constructor(props) {
    super(props, { type: Type.Delete, types: DeleteFlowsteps });
    makeObservable(this);

    this.options = {
      ...this.options,
      idColumnName: '',
      deleteRowsInTable: false,
    };

    const allReactions = [...super.setupBaseReactions()];
    this.cleanReactions = () => allReactions.forEach(dispose => dispose());
  }

  @computed get _generatedName_() {
    const { worksheetName, targetCell: target } = this.selectionTarget || {};
    return generateFlowstepName({ type: this.type, worksheetName, target });
  }

  @computed get _isValid_() {
    return this.excelHeaders.length && !!this.options.idColumnName && super.areAllOptionsValid;
  }

  @computed get columnWithIdsHeaders() {
    return this.excelHeaders
      .map(x => ({ key: x, text: x, excelColumnName: x }));
  }

  @computed get isDelete() {
    return this.type === Type.Delete;
  }

  _renderTypeAction_() {
    return (
      <Checkbox
        label="Delete Rows In Table"
        checked={this.options.deleteRowsInTable}
        disabled={!this.isDelete || this._readOnly_}
        onChange={(_, checked) => this.handleOptionsChange('deleteRowsInTable', checked)}
      />
    );
  }

  _renderCustomSteps_({ getStepTitle }) {
    return (
      <Step title={getStepTitle('Select column with IDs')}>
        <SearchableComboBox
          placeholder="Select column"
          selectedKey={this.options.idColumnName || -1}
          onChange={async (_, item) => this.handleOptionsChange('idColumnName', item.excelColumnName)}
          options={this.columnWithIdsHeaders}
          disabled={!this.columnWithIdsHeaders.length || this._readOnly_}
        />
      </Step>
    );
  }

  @action _setSelectionTarget_(selectionTarget) {
    super._setSelectionTarget_(selectionTarget);
    this.options.idColumnName = this.excelHeaders.find(x => x.toLowerCase().includes('id')) || '';
  }

  async _loadFlowstep_(flowstep, isExact = true) {
    const { idColumnName, deleteRowsInTable } = flowstep.options;
    this.options = {
      ...this.options,
      idColumnName, deleteRowsInTable
    };

    isExact && super.loadFlowstep(flowstep, isExact);
  }

  async _makeFlowstep_(makeCopy) {
    const flowstep = super.makeFlowstep(makeCopy);
    const { idColumnName, deleteRowsInTable } = this.options
    Object.assign(flowstep.options, {
      idColumnName, deleteRowsInTable,
    });
    return flowstep;
  }
}


export const DeleteData = (props) => <DeleteDataImpl type={Type.Delete} {...props} />;
export const UndeleteData = (props) => <DeleteDataImpl type={Type.Undelete} {...props} />;